import styled from 'styled-components';

export const InputPasswordWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 30px;
`;
